import { useContext } from "preact/hooks";
import { EditContext } from "./edits";
import type { Labels } from "./labels";
import { Mark } from "./pop";
import type { SheetView } from "./sheet_view";

export type Spent = Set<string>;

export const spentSet = (view: SheetView): Spent => new Set(view.sheet.resource_uses ?? []);

// An ability's, a ritual's or a spell's use boxes, in the order of their keys; a button for whoever may edit.
export function Uses({ name, uses, spent, labels }: { name: string; uses: string[]; spent: Spent; labels: Labels }) {
	const edits = useContext(EditContext);
	return (
		<span class="inline-flex flex-wrap gap-1 align-middle">
			{uses.map((key) => (
				<Mark
					key={key}
					on={spent.has(key)}
					label={`${name}: ${spent.has(key) ? labels.boxes.used : labels.boxes.available}`}
					onToggle={edits && ((used) => edits.toggleUse(key, used))}
				/>
			))}
		</span>
	);
}
